export default __webpack_public_path__ + "static/media/970.be2a6896.png";